import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card, Alert, ProgressBar, Badge, InputGroup } from "react-bootstrap";
import "../componentCss/webform.css";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import Dashboardheader from "./dashboardheader";
import Sidebar from "./sidebar";
import "../componentCss/sidebar.css";
import toast, { Toaster } from 'react-hot-toast';
import "react-toastify/dist/ReactToastify.css";
import { BsArrowLeftCircleFill, BsEyeSlashFill, BsEyeFill, BsUpload, BsTrash, BsCheck, BsX } from "react-icons/bs";
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaBuilding, FaIdBadge, FaCalendarAlt, FaImage, FaFileSignature, FaUserTie } from "react-icons/fa";
import { MdSecurity, MdWork, MdLocationOn } from "react-icons/md";
import config from "../../config/config";
import { Link } from "react-router-dom";
import { addStaffSchema } from "../../validations/staffSchema";
import { addStaffAction, getGroupTypesAction, getDepartmentListAction } from "../../Action/modernAdminActions";
import { useMigrationHelper, createMigratedAction } from '../../utils/migrationHelper';
import { decryptData } from "./decrypt";
import Select from 'react-select';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

const AddStaff = () => {
  const navigate = useNavigate();
  const { useModernAPI } = useMigrationHelper();
  
  // Country codes for mobile number
  const countryCodes = [
    { code: '+971', name: 'UAE', flag: '🇦🇪' },
    { code: '+91', name: 'India', flag: '🇮🇳' },
    { code: '+1', name: 'USA/Canada', flag: '🇺🇸' },
    { code: '+44', name: 'UK', flag: '🇬🇧' },
    { code: '+61', name: 'Australia', flag: '🇦🇺' },
    { code: '+81', name: 'Japan', flag: '🇯🇵' }
  ];

  const [formData, setForm] = useState({
    name_prefix: "Mr",
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
    phone_country_code: "+971",
    phone_number: "",
    address: "",
    city: "",
    state: "",
    gender: 0,
    roles: [],
    department: null,
    designation: "",
    specialty: "",
    is_time_slot: "",
    employee_id: "",
    emirates_id_number: "",
    date_of_joining: "",
    license_number: "",
    stamp_image: null,
    photo: null,
    signature: null,
    prefix: ""
  });
  const [userGroup, setUserGroup] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [isLaoding, setisLaoding] = useState(0);
  const [image_preview, setimage_preview] = useState("");
  const [imagePhotoPreview, setPhotopreview] = useState("");
  const [imageSignaturepreview, setSignaturepreview] = useState("");
  const [passwordData, setPasswordData] = useState(1)
  const [confirmPasswordData, setConfirmPasswordData] = useState(1)
  const [formProgress, setFormProgress] = useState(0);
  const [currentStep, setCurrentStep] = useState(1);
  const [uploadProgress, setUploadProgress] = useState({
    photo: 0,
    signature: 0,
    stamp_image: 0
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [validationMessages, setValidationMessages] = useState({});

  // Scroll to first error field utility function
  const scrollToFirstError = (errors, touched) => {
    console.log('scrollToFirstError called with:', { errors, touched });
    
    // Define required fields that should trigger scroll (fields with red asterisk)
    const requiredFields = [
      'first_name', 'last_name', 'email', 'phone_number', 
      'password', 'confirm_password', 'employee_id', 'emirates_id_number', 
      'gender', 'date_of_joining', 'department', 'roles', 'specialty'
    ];
    
    // Find the first required field with an error
    const firstErrorField = requiredFields.find(fieldName => 
      errors[fieldName] // Don't check touched since we set all fields as touched
    );
    
    console.log('First error field:', firstErrorField);
    
    if (firstErrorField) {
      // Use setTimeout to ensure DOM updates have completed
      setTimeout(() => {
        let targetElement = null;
        
        // Simple, reliable selectors first
        const basicSelectors = [
          `input[name="${firstErrorField}"]`,
          `select[name="${firstErrorField}"]`,
          `textarea[name="${firstErrorField}"]`,
        ];
        
        // Special handling for React Select components
        if (firstErrorField === 'department' || firstErrorField === 'roles') {
          basicSelectors.push(
            `.select__control:not([aria-expanded="true"])`, // Target any closed Select
            `.basic-multi-select .select__control`,
            `[class*="select"] .select__control`
          );
        }
        
        // Try basic selectors first
        for (const selector of basicSelectors) {
          const elements = document.querySelectorAll(selector);
          console.log(`Selector "${selector}" found ${elements.length} elements`);
          if (elements.length > 0) {
            targetElement = elements[0];
            break;
          }
        }
        
        // Fallback: find by label text matching the field name
        if (!targetElement) {
          const fieldDisplayName = firstErrorField.replace('_', ' ').toLowerCase();
          const formGroups = document.querySelectorAll('.form-group, [class*="mb-"], .row > div');
          
          for (const group of formGroups) {
            const label = group.querySelector('label');
            if (label && label.textContent.toLowerCase().includes(fieldDisplayName)) {
              const input = group.querySelector('input, select, textarea, .select__control');
              if (input) {
                targetElement = input;
                console.log(`Found element by label matching for "${fieldDisplayName}":`, targetElement);
                break;
              }
            }
          }
        }
        
        if (targetElement) {
          console.log('Scrolling to element:', targetElement);
          
          // Scroll to the field with smooth animation
          targetElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center',
            inline: 'nearest'
          });
          
          // Focus the field for better accessibility (if it's focusable)
          try {
            if (targetElement.focus && typeof targetElement.focus === 'function') {
              setTimeout(() => targetElement.focus(), 200);
            }
          } catch (e) {
            console.log('Could not focus element:', e);
          }
        } else {
          console.log('Could not find target element for field:', firstErrorField);
        }
      }, 150); // Slightly longer timeout to ensure DOM updates
    }
  };

  // Phone number formatting function
  const formatPhoneNumber = (value) => {
    // Remove all non-digits
    return value.replace(/\D/g, '');
  };

  // Handle phone number change
  const handlePhoneChange = (e, setFieldValue) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    setFieldValue('phone_number', formattedPhone);
  };

  useEffect(() => {
    getGroupTypesAPI();
    getDepartmentListAPI();
  }, []);

  let getDepartmentListAPI = async () => {
    try {
      let res = await getDepartmentListAction();
      if (res.success) {
        const data = res.data;
        const transformedData = data.map(item => ({
          value: String(item.id || item.department_id).replace(/"/g, ''),
          label: item.name
        }));
        setDepartmentList(transformedData);
      }
    } catch (error) {
      console.error('Failed to load departments:', error);
    }
  };

  let getGroupTypesAPI = async () => {
    try {
      let res = await getGroupTypesAction();

      if (res.success) {
        const data = res.data?.items || res.data;

        const transformedData = data.map(item => ({
          value: item.role_id || item.id,
          label: item.display_name || item.name
        }));

        setUserGroup(transformedData);
      }
    } catch (error) {
      console.error('Failed to load user groups:', error);
      toast.error('Failed to load roles. Please try again.');
    }
  };

  const passWordDisplay = async (e, data) => {
    e.preventDefault()
    if (data == 1) {
      setPasswordData(2)
    }
    else {
      setPasswordData(1)

    }
  }

  const confirmPassWordDisplay = async (e, data) => {
    e.preventDefault()
    if (data == 1) {
      setConfirmPasswordData(2)
    }
    else {
      setConfirmPasswordData(1)

    }
  }

  let handleSubmit = async (values) => {
    try {
      setisLaoding(1);

      const submissionData = {
        ...values,
        department: values.department ? String(values.department.value).replace(/"/g, '') : undefined,
        // Extract role IDs from the selected role objects
        roles: values.roles && Array.isArray(values.roles) ? values.roles.map(role => {
          // Extract the value (role ID) from the React Select option object
          return role.value;
        }) : [],
        gender: values.gender,
        phone: values.phone_country_code + values.phone_number, // Backend expects this field
        phone_primary: values.phone_country_code + values.phone_number, // For consistency
      };

      // Remove form-specific phone fields from API submission
      delete submissionData.phone_country_code;
      delete submissionData.phone_number;
      // Simulate progress updates
      const progressInterval = setInterval(() => {
        setFormProgress(prev => {
          if (prev < 90) return prev + 10;
          return prev;
        });
      }, 200);

      let res;
      if (useModernAPI) {
        res = await addStaffAction(submissionData);
      } else {
        const { addStaffAction: legacyAddStaffAction } = await import('../../Action/admin.action');
        res = await legacyAddStaffAction(submissionData);
      }

      clearInterval(progressInterval);
      setFormProgress(100);

      if (res.success) {
        toast.success(
          <div>
            <strong>Success!</strong><br />
            {res.message || res.msg}
          </div>
        );
        setTimeout(() => {
          navigate(`${config.baseUrl}staff-management`);
        }, 2000);
      } else {
        setisLaoding(0);
        setFormProgress(0);
        // Error will be handled by global error handler
        console.error('Staff addition failed:', res.message || res.msg);
      }
    } catch (error) {
      setisLaoding(0);
      setFormProgress(0);

      // Handle RBAC/Permission errors (403) explicitly
      const status = error?.response?.status;
      if (status === 403) {
        toast.error(error?.response?.data?.detail || 'You do not have permission to create staff.');
        return;
      }

      // Error will be handled by global error handler
      console.error('Staff addition error:', error);
    }
  };

  const handleChangeForstampImage = async (e, setFieldValue) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      // Validate file type and size
      if (!file.type.startsWith('image/')) {
        toast.error('Please select a valid image file');
        return;
      }
      if (file.size > 5 * 1024 * 1024) { // 5MB limit
        toast.error('File size must be less than 5MB');
        return;
      }

      setUploadProgress(prev => ({ ...prev, stamp_image: 0 }));

      // Simulate upload progress
      const progressInterval = setInterval(() => {
        setUploadProgress(prev => {
          if (prev.stamp_image < 100) {
            return { ...prev, stamp_image: prev.stamp_image + 10 };
          }
          clearInterval(progressInterval);
          return prev;
        });
      }, 100);

      let image_as_base64 = URL.createObjectURL(file);
      setFieldValue("stamp_image", file);
      setimage_preview(image_as_base64);
    }
  };

  const handleChangeForPhoto = async (e, setFieldValue) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      // Validate file type and size
      if (!file.type.startsWith('image/')) {
        toast.error('Please select a valid image file');
        return;
      }
      if (file.size > 5 * 1024 * 1024) { // 5MB limit
        toast.error('File size must be less than 5MB');
        return;
      }

      setUploadProgress(prev => ({ ...prev, photo: 0 }));

      // Simulate upload progress
      const progressInterval = setInterval(() => {
        setUploadProgress(prev => {
          if (prev.photo < 100) {
            return { ...prev, photo: prev.photo + 10 };
          }
          clearInterval(progressInterval);
          return prev;
        });
      }, 100);

      let image_as_base64 = URL.createObjectURL(file);
      setFieldValue("photo", file);
      setPhotopreview(image_as_base64);
    }
  };

  const handleChangeForSignature = async (e, setFieldValue) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      // Validate file type and size
      if (!file.type.startsWith('image/')) {
        toast.error('Please select a valid image file');
        return;
      }
      if (file.size > 5 * 1024 * 1024) { // 5MB limit
        toast.error('File size must be less than 5MB');
        return;
      }

      setUploadProgress(prev => ({ ...prev, signature: 0 }));

      // Simulate upload progress
      const progressInterval = setInterval(() => {
        setUploadProgress(prev => {
          if (prev.signature < 100) {
            return { ...prev, signature: prev.signature + 10 };
          }
          clearInterval(progressInterval);
          return prev;
        });
      }, 100);

      let image_as_base64 = URL.createObjectURL(file);
      setFieldValue("signature", file);
      setSignaturepreview(image_as_base64);
    }
  };

  const clearImagePreview = (type, setFieldValue) => {
    switch (type) {
      case 'stamp':
        setimage_preview('');
        setFieldValue('stamp_image', null);
        break;
      case 'photo':
        setPhotopreview('');
        setFieldValue('photo', null);
        break;
      case 'signature':
        setSignaturepreview('');
        setFieldValue('signature', null);
        break;
    }
  };

  const calculateFormCompletion = (values) => {
    const requiredFields = [
      'first_name', 'last_name', 'email', 'password', 'phone_number',
      'employee_id', 'emirates_id_number', 'gender', 'date_of_joining'
    ];
    const filledFields = requiredFields.filter(field => values[field] && values[field].toString().trim() !== '');
    return Math.round((filledFields.length / requiredFields.length) * 100);
  };

  const getFieldValidationStatus = (fieldName, errors, touched) => {
    if (touched[fieldName]) {
      return errors[fieldName] ? 'error' : 'success';
    }
    return null;
  };

  const renderFieldWithIcon = (icon, children, error, touched) => {
    const status = touched && !error ? 'success' : touched && error ? 'error' : null;
    return (
      <InputGroup className={`mb-3 ${status === 'error' ? 'border-danger' : status === 'success' ? 'border-success' : ''}`}>
        <InputGroup.Text className={`${status === 'error' ? 'text-danger' : status === 'success' ? 'text-success' : ''}`}>
          {icon}
        </InputGroup.Text>
        {children}
        {status === 'success' && (
          <InputGroup.Text className="text-success">
            <BsCheck size={20} />
          </InputGroup.Text>
        )}
      </InputGroup>
    );
  };




  return (
    <>
      <style>
        {`
          .req {
            color: #dc3545;
            margin-left: 2px;
          }
          .country-code-select {
            max-width: 150px;
            border-right: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
          .phone-input {
            border-left: 0;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        `}
      </style>
      <Dashboardheader />
      <div className="wrapper">
        <Sidebar />
        <div id="content">
          <Container fluid className="p-4">
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h5 className="headtitle mb-1">Add New Staff Member</h5>
                    <small className="text-muted">Create a new staff account with proper permissions</small>
                  </div>
                  <Link to={`${config.baseUrl}staff-management`}>
                    <Button variant="outline-secondary" size="sm" className="d-flex align-items-center gap-2">
                      <BsArrowLeftCircleFill size={16} />
                      Back to Staff List
                    </Button>
                  </Link>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <Card className="border-0 shadow-sm">
                  <Card.Body className="p-4">
                    <Formik
                      initialValues={formData}
                      validationSchema={addStaffSchema}
                      onSubmit={(values, { setSubmitting }) => {
                        // If form validation passes, this function runs
                        handleSubmit(values);
                      }}
                    >
                      {({
                        errors,
                        handleSubmit,
                        handleBlur,
                        handleChange,
                        touched,
                        setFieldValue,
                        setTouched,
                        values,
                        isValid,
                        submitCount
                      }) => {
                        const completionPercentage = calculateFormCompletion(values);

                        // Custom submit handler to handle validation errors
                        const handleFormSubmit = (e) => {
                          e.preventDefault();
                          
                          // Mark all fields as touched to show validation errors
                          const touchedFields = {};
                          Object.keys(values).forEach(key => {
                            touchedFields[key] = true;
                          });
                          setTouched(touchedFields);

                          // Filter errors to only show errors for required fields (fields with red asterisk)
                          const requiredFields = [
                            'first_name', 'last_name', 'email', 'phone_number',
                            'password', 'confirm_password', 'employee_id', 'emirates_id_number',
                            'gender', 'date_of_joining', 'department', 'roles', 'specialty'
                          ];

                          const requiredFieldErrors = {};
                          requiredFields.forEach(field => {
                            if (errors[field]) {
                              requiredFieldErrors[field] = errors[field];
                            }
                          });

                          // Check if there are any required field errors
                          const hasRequiredFieldErrors = Object.keys(requiredFieldErrors).length > 0;

                          if (!hasRequiredFieldErrors) {
                            // No required field errors, proceed with submission
                            handleSubmit(e);
                          } else {
                            // Form has validation errors in required fields
                            
                            setTimeout(() => {
                              scrollToFirstError(requiredFieldErrors, touchedFields);
                              toast.error("Please correct the highlighted errors and try again.");
                            }, 100);
                          }
                        };

                        return (
                          <Form onSubmit={handleFormSubmit}>
                            {/* Form Progress */}
                            <div className="mb-4">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="text-muted">Form Completion</span>
                                <span className="text-primary font-weight-bold">{completionPercentage}%</span>
                              </div>
                              <ProgressBar
                                now={completionPercentage}
                                variant={completionPercentage < 50 ? 'danger' : completionPercentage < 80 ? 'warning' : 'success'}
                                style={{ height: '8px' }}
                              />
                            </div>

                            {/* Form Sections */}
                            <div className="mb-4">
                              <h6 className="text-primary mb-3 border-bottom pb-2">
                                <FaUser className="me-2" />
                                Personal Information
                              </h6>
                            </div>


                            <Row className="mb-4">
                              <Form.Group as={Col} lg={3}>
                                <Form.Label>Prefix</Form.Label>
                                <Form.Select name="name_prefix" onChange={handleChange} value={values.name_prefix}>
                                  <option value="Mr">Mr</option>
                                  <option value="Ms">Ms</option>
                                  <option value="Miss">Miss</option>
                                  <option value="Mrs">Mrs</option>
                                  <option value="Master">Master</option>
                                  <option value="Fr">Father (Fr)</option>
                                  <option value="Rev">Reverend (Rev)</option>
                                  <option value="Dr">Doctor (Dr)</option>
                                  <option value="Atty">Attorney (Atty)</option>
                                  <option value="Hon">Honorable (Hon)</option>
                                  <option value="Prof">Professor (Prof)</option>
                                  <option value="Pres">President (Pres)</option>
                                  <option value="VP">Vice President (VP)</option>
                                  <option value="Gov">Governor (Gov)</option>
                                </Form.Select>
                              </Form.Group>
                              <Col lg={9}></Col>
                            </Row>

                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>First name <span className="req">*</span></Form.Label>
                                {renderFieldWithIcon(
                                  <FaUser size={16} />,
                                  <Form.Control
                                    type="text"
                                    name="first_name"
                                    onChange={handleChange}
                                    placeholder="Enter first name"
                                    onBlur={handleBlur}
                                    value={values.first_name}
                                    isInvalid={errors.first_name && touched.first_name}
                                    isValid={!errors.first_name && touched.first_name && values.first_name}
                                    aria-required="true"
                                    aria-invalid={errors.first_name && touched.first_name ? "true" : "false"}
                                    aria-describedby={errors.first_name && touched.first_name ? "first_name-error" : undefined}
                                  />,
                                  errors.first_name,
                                  touched.first_name
                                )}
                                <Form.Control.Feedback type="invalid" id="first_name-error">
                                  {errors.first_name}
                                </Form.Control.Feedback>
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label>Middle name</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="middle_name"
                                  onChange={handleChange}
                                  placeholder="Enter middle name (optional)"
                                  onBlur={handleBlur}
                                  value={values.middle_name}
                                />
                              </Form.Group>
                            </Row>
                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>Last name <span className="req">*</span></Form.Label>
                                {renderFieldWithIcon(
                                  <FaUser size={16} />,
                                  <Form.Control
                                    type="text"
                                    name="last_name"
                                    onChange={handleChange}
                                    value={values.last_name}
                                    placeholder="Enter last name"
                                    onBlur={handleBlur}
                                    isInvalid={errors.last_name && touched.last_name}
                                    isValid={!errors.last_name && touched.last_name && values.last_name}
                                    aria-required="true"
                                    aria-invalid={errors.last_name && touched.last_name ? "true" : "false"}
                                    aria-describedby={errors.last_name && touched.last_name ? "last_name-error" : undefined}
                                  />,
                                  errors.last_name,
                                  touched.last_name
                                )}
                                <Form.Control.Feedback type="invalid" id="last_name-error">
                                  {errors.last_name}
                                </Form.Control.Feedback>
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label>Employee ID <span className="req">*</span></Form.Label>
                                {renderFieldWithIcon(
                                  <FaIdBadge size={16} />,
                                  <Form.Control
                                    type="text"
                                    name="employee_id"
                                    onChange={handleChange}
                                    value={values.employee_id}
                                    placeholder="Enter Employee ID"
                                    onBlur={handleBlur}
                                    isInvalid={errors.employee_id && touched.employee_id}
                                    aria-required="true"
                                    aria-invalid={errors.employee_id && touched.employee_id ? "true" : "false"}
                                    aria-describedby={errors.employee_id && touched.employee_id ? "employee_id-error" : undefined}
                                  />,
                                  errors.employee_id,
                                  touched.employee_id
                                )}
                                <Form.Control.Feedback type="invalid" id="employee_id-error">
                                  {errors.employee_id}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Row>

                            <div className="mb-4">
                              <h6 className="text-primary mb-3 border-bottom pb-2">
                                <MdSecurity className="me-2" />
                                Contact & Security
                              </h6>
                            </div>

                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>Email <span className="req">*</span></Form.Label>
                                {renderFieldWithIcon(
                                  <FaEnvelope size={16} />,
                                  <Form.Control
                                    type="email"
                                    name="email"
                                    onChange={handleChange}
                                    value={values.email}
                                    placeholder="Enter email address"
                                    onBlur={handleBlur}
                                    isInvalid={errors.email && touched.email}
                                    isValid={!errors.email && touched.email && values.email}
                                    aria-required="true"
                                    aria-invalid={errors.email && touched.email ? "true" : "false"}
                                    aria-describedby={errors.email && touched.email ? "email-error" : undefined}
                                  />,
                                  errors.email,
                                  touched.email
                                )}
                                <Form.Control.Feedback type="invalid" id="email-error">
                                  {errors.email}
                                </Form.Control.Feedback>
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label>Phone Number <span className="req">*</span></Form.Label>
                                <div className="d-flex gap-2">
                                  <Form.Select
                                    name="phone_country_code"
                                    onChange={handleChange}
                                    value={values.phone_country_code}
                                    style={{ maxWidth: '140px', minWidth: '140px' }}
                                    onBlur={handleBlur}
                                    aria-required="true"
                                  >
                                    {countryCodes.map((country) => (
                                      <option key={country.code} value={country.code}>
                                        {country.flag} {country.code}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <Form.Control
                                    type="tel"
                                    name="phone_number"
                                    onChange={(e) => handlePhoneChange(e, setFieldValue)}
                                    value={values.phone_number}
                                    placeholder="Enter phone number"
                                    onBlur={handleBlur}
                                    isInvalid={errors.phone_number && touched.phone_number}
                                    isValid={!errors.phone_number && touched.phone_number && values.phone_number}
                                    aria-required="true"
                                    aria-invalid={errors.phone_number && touched.phone_number ? "true" : "false"}
                                    aria-describedby={errors.phone_number && touched.phone_number ? "phone_number-error" : "phone_number-help"}
                                    style={{ flex: 1 }}
                                  />
                                </div>
                                {errors.phone_number && touched.phone_number && (
                                  <Form.Control.Feedback type="invalid" style={{ display: 'block' }} id="phone_number-error">
                                    {errors.phone_number}
                                  </Form.Control.Feedback>
                                )}
                                <Form.Text className="text-muted" id="phone_number-help">
                                  Select country code and enter phone number without country code
                                </Form.Text>
                              </Form.Group>
                            </Row>

                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>Password <span className="req">*</span></Form.Label>
                                <InputGroup>
                                  <InputGroup.Text>
                                    <MdSecurity size={16} />
                                  </InputGroup.Text>
                                  <Form.Control
                                    type={passwordData == 1 ? "password" : "text"}
                                    name="password"
                                    onChange={handleChange}
                                    value={values.password}
                                    placeholder="Enter strong password"
                                    onBlur={handleBlur}
                                    isInvalid={errors.password && touched.password}
                                    isValid={!errors.password && touched.password && values.password}
                                    aria-required="true"
                                    aria-invalid={errors.password && touched.password ? "true" : "false"}
                                    aria-describedby={errors.password && touched.password ? "password-error" : "password-help"}
                                  />
                                  <Button
                                    variant="outline-secondary"
                                    onClick={(e) => passWordDisplay(e, passwordData)}
                                    type="button"
                                  >
                                    {passwordData == 1 ?
                                      <BsEyeSlashFill size={16} /> :
                                      <BsEyeFill size={16} />
                                    }
                                  </Button>
                                </InputGroup>
                                <Form.Control.Feedback type="invalid" id="password-error">
                                  {errors.password}
                                </Form.Control.Feedback>
                                <Form.Text className="text-muted" id="password-help">
                                  Must be at least 8 characters with uppercase, lowercase, numbers, and special characters
                                </Form.Text>
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label>Confirm Password <span className="req">*</span></Form.Label>
                                <InputGroup>
                                  <InputGroup.Text>
                                    <MdSecurity size={16} />
                                  </InputGroup.Text>
                                  <Form.Control
                                    type={confirmPasswordData == 1 ? "password" : "text"}
                                    name="confirm_password"
                                    value={values.confirm_password}
                                    onChange={handleChange}
                                    placeholder="Confirm password"
                                    onBlur={handleBlur}
                                    isInvalid={errors.confirm_password && touched.confirm_password}
                                    isValid={!errors.confirm_password && touched.confirm_password && values.confirm_password && values.password === values.confirm_password}
                                    aria-required="true"
                                    aria-invalid={errors.confirm_password && touched.confirm_password ? "true" : "false"}
                                    aria-describedby={errors.confirm_password && touched.confirm_password ? "confirm_password-error" : undefined}
                                  />
                                  <Button
                                    variant="outline-secondary"
                                    onClick={(e) => confirmPassWordDisplay(e, confirmPasswordData)}
                                    type="button"
                                  >
                                    {confirmPasswordData == 1 ?
                                      <BsEyeSlashFill size={16} /> :
                                      <BsEyeFill size={16} />
                                    }
                                  </Button>
                                </InputGroup>
                                <Form.Control.Feedback type="invalid" id="confirm_password-error">
                                  {errors.confirm_password}
                                </Form.Control.Feedback>
                                {values.password && values.confirm_password && values.password === values.confirm_password && (
                                  <div className="text-success small mt-1">
                                    <BsCheck className="me-1" />Passwords match
                                  </div>
                                )}
                              </Form.Group>
                            </Row>

                            <div className="mb-4">
                              <h6 className="text-primary mb-3 border-bottom pb-2">
                                <FaMapMarkerAlt className="me-2" />
                                Location Information
                              </h6>
                            </div>

                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>City</Form.Label>
                                {renderFieldWithIcon(
                                  <MdLocationOn size={16} />,
                                  <Form.Control
                                    type="text"
                                    name="city"
                                    onChange={handleChange}
                                    value={values.city}
                                    placeholder="Enter city"
                                    onBlur={handleBlur}
                                  />,
                                  null, // No error to display
                                  touched.city
                                )}
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label>Address</Form.Label>
                                {renderFieldWithIcon(
                                  <FaMapMarkerAlt size={16} />,
                                  <Form.Control
                                    type="text"
                                    name="address"
                                    onChange={handleChange}
                                    value={values.address}
                                    placeholder="Enter full address"
                                    onBlur={handleBlur}
                                  />,
                                  null, // No error to display
                                  touched.address
                                )}
                              </Form.Group>
                            </Row>
                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>State</Form.Label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="state"
                                  onChange={handleChange}
                                  value={values.state}
                                  placeholder="Please enter state"
                                />
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label>Emirates ID number <span className="req">*</span></Form.Label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="emirates_id_number"
                                  onChange={handleChange}
                                  value={values.emirates_id_number}
                                  placeholder="Please enter Emirates ID number"
                                  onBlur={handleBlur}
                                  aria-required="true"
                                  aria-invalid={errors.emirates_id_number && touched.emirates_id_number ? "true" : "false"}
                                  aria-describedby={errors.emirates_id_number && touched.emirates_id_number ? "emirates_id_number-error" : undefined}
                                />

                                {errors.emirates_id_number &&
                                  touched.emirates_id_number && (
                                    <div className="text-danger" id="emirates_id_number-error">
                                      {errors.emirates_id_number}
                                    </div>
                                  )}
                              </Form.Group>
                            </Row>
                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>Gender <span className="req">*</span></Form.Label>
                                <select
                                  name="gender"
                                  value={values.gender}
                                  className="form-control"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  aria-required="true"
                                  aria-invalid={errors.gender && touched.gender ? "true" : "false"}
                                  aria-describedby={errors.gender && touched.gender ? "gender-error" : undefined}
                                >
                                  <option value={""}>Select gender</option>
                                  <option value={1}>Male</option>
                                  <option value={2}>Female</option>
                                  <option value={3}>Other</option>
                                </select>

                                {errors.gender && touched.gender && (
                                  <div className="text-danger" id="gender-error">{errors.gender}</div>
                                )}
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label>Department <span className="req">*</span></Form.Label>
                                <Select
                                  name="department"
                                  options={departmentList}
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  onChange={(selectedOption) => setFieldValue("department", selectedOption)}
                                  onBlur={handleBlur}
                                  value={values.department}
                                  aria-required="true"
                                  aria-invalid={errors.department && touched.department ? "true" : "false"}
                                  aria-describedby={errors.department && touched.department ? "department-error" : undefined}
                                />
                                {errors.department && touched.department && (
                                  <div className="text-danger" id="department-error">
                                    {errors.department}
                                  </div>
                                )}
                              </Form.Group>
                            </Row>

                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>Specialty <span className="req">*</span></Form.Label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="specialty"
                                  onChange={handleChange}
                                  value={values.specialty}
                                  placeholder="Please enter specialty"
                                  aria-required="true"
                                  aria-invalid={errors.specialty && touched.specialty ? "true" : "false"}
                                  aria-describedby={errors.specialty && touched.specialty ? "specialty-error" : undefined}
                                />

                                {errors.specialty && touched.specialty && (
                                  <div className="text-danger" id="specialty-error">
                                    {errors.specialty}
                                  </div>
                                )}
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label>Designation</Form.Label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="designation"
                                  onChange={handleChange}
                                  value={values.designation}
                                  placeholder="Please enter designation"
                                />
                              </Form.Group>
                            </Row>



                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>Roles <span className="req">*</span></Form.Label>
                                <Select
                                  name="roles"
                                  isMulti
                                  options={userGroup}
                                  value={values.roles}
                                  onChange={(selectedOptions) => {
                                    setFieldValue('roles', selectedOptions || []);
                                  }}
                                  onBlur={() => setFieldValue('roles', values.roles)}
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  placeholder="Select roles..."
                                  aria-required="true"
                                  aria-invalid={errors.roles && touched.roles ? "true" : "false"}
                                  aria-describedby={errors.roles && touched.roles ? "roles-error" : undefined}
                                />
                                {errors.roles && touched.roles && (
                                  <div className="text-danger" id="roles-error">
                                    {errors.roles}
                                  </div>
                                )}
                                {!errors.roles && touched.roles && values.roles && values.roles.length > 0 && (
                                  <div className="text-success small mt-1">
                                    <BsCheck className="me-1" />
                                    {values.roles.length} role{values.roles.length > 1 ? 's' : ''} selected
                                  </div>
                                )}
                                <Form.Text className="text-muted">
                                  Select one or more roles for this staff member.
                                  {userGroup.length > 0
                                    ? ` Available roles: ${userGroup.length} options loaded.`
                                    : " Loading roles..."
                                  }
                                </Form.Text>
                              </Form.Group>
                            </Row>

                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>Stamp Image</Form.Label>
                                <input
                                  className="form-control"
                                  type="file"
                                  name="stamp_image"
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleChangeForstampImage(e, setFieldValue)
                                  }
                                />

                                {image_preview ? (
                                  <>
                                    <img
                                      src={image_preview}
                                      width="100px"
                                      height="100px"
                                      style={{
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                      }}
                                    />
                                  </>
                                ) : (
                                  ""
                                )}
                              </Form.Group>
                            </Row>
                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>Photo</Form.Label>
                                <input
                                  className="form-control"
                                  type="file"
                                  name="photo"
                                  accept="image/*"
                                  onChange={(e) => handleChangeForPhoto(e, setFieldValue)}
                                />

                                {imagePhotoPreview ? (
                                  <>
                                    <img
                                      src={imagePhotoPreview}
                                      width="100px"
                                      height="100px"
                                      style={{
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                      }}
                                    />
                                  </>
                                ) : (
                                  ""
                                )}
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label>Signature</Form.Label>
                                <input
                                  className="form-control"
                                  type="file"
                                  name="signature"
                                  accept="image/*"
                                  onChange={(e) => handleChangeForSignature(e, setFieldValue)}
                                />

                                {imageSignaturepreview ? (
                                  <>
                                    <img
                                      src={imageSignaturepreview}
                                      width="100px"
                                      height="100px"
                                      style={{
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                      }}
                                    />
                                  </>
                                ) : (
                                  ""
                                )}
                              </Form.Group>
                            </Row>

                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                <Form.Label>Date of joining <span className="req">*</span></Form.Label>
                                <input
                                  className="form-control"
                                  type="date"
                                  name="date_of_joining"
                                  onChange={handleChange}
                                  value={values.date_of_joining}
                                  placeholder="Please enter Date of Joining"
                                  onBlur={handleBlur}
                                  aria-required="true"
                                  aria-invalid={errors.date_of_joining && touched.date_of_joining ? "true" : "false"}
                                  aria-describedby={errors.date_of_joining && touched.date_of_joining ? "date_of_joining-error" : undefined}
                                />

                                {errors.date_of_joining && touched.date_of_joining && (
                                  <div className="text-danger" id="date_of_joining-error">
                                    {errors.date_of_joining}
                                  </div>
                                )}
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label>License Number</Form.Label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="license_number"
                                  onChange={handleChange}
                                  placeholder="Please enter Licence Number "
                                  value={values.license_number}
                                />
                              </Form.Group>
                            </Row>

                            <br />
                            <Row className="mb-4">
                              <Form.Group as={Col}>
                                {isLaoding ? (
                                  <>
                                    <button
                                      disabled
                                      className="btn-sm btn btn-primary"
                                    >
                                      Loading{" "}
                                      <img
                                        height="20"
                                        width="20px"
                                        src="assets/images/loading.gif"
                                      />
                                    </button>
                                  </>
                                ) : (
                                  <button
                                    type="submit"
                                    className="btn-sm btn btn-primary"
                                    disabled={isLaoding}
                                  >
                                    Submit
                                  </button>
                                )}
                                <Link to={`${config.baseUrl}staff-management`}>
                                  <Button variant="outline-secondary" disabled={isLaoding} style={{ marginLeft: '20px', backgroundColor: '#e7e0e0' }}>
                                    Cancel
                                  </Button>
                                </Link>
                              </Form.Group>

                            </Row>
                            {/* Submit Button */}
                            {/* <div className="border-top pt-4 mt-4">
                              <Row>
                                <Col lg={6}>
                                  {isLaoding && (
                                    <div className="mb-3">
                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                        <span className="text-muted">Creating staff member...</span>
                                        <span className="text-primary">{formProgress}%</span>
                                      </div>
                                      <ProgressBar now={formProgress} variant="primary" style={{ height: '6px' }} />
                                    </div>
                                  )}
                                  <div className="d-flex gap-3">
                                    <Button
                                      type="submit"
                                      variant="primary"
                                      disabled={isLaoding}
                                      className="d-flex align-items-center gap-2"
                                    >
                                      {isLaoding ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                          Creating...
                                        </>
                                      ) : (
                                        <>
                                          <BsCheck size={16} />
                                          Create Staff Member
                                        </>
                                      )}
                                    </Button>
                                    <Link to={`${config.baseUrl}staff-management`}>
                                      <Button variant="outline-secondary" disabled={isLaoding}>
                                        Cancel
                                      </Button>
                                    </Link>
                                  </div>
                                </Col>
                              </Row>
                            </div> */}
                          </Form>
                        );
                      }}
                    </Formik>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div >
    </>
  );
};


export default AddStaff;
